@if (rolesLoaded()) {
<div class="home-container">
  <div class="home-header">
    <div class="home-header__title">
      <dsy-breadcrumbs [breadcrumbsNameList]="breadcrumbsSignal()" color="black"
        selected-variant="v-bold-black" separator-color="s-secondary" string-separator="/"
        [callbackClick]="onClickBreadcrumb"></dsy-breadcrumbs>
      <dsy-tabs [centered]="false" [variant]="'browsing'" [tabsToRender]="tabs()" density="compact"
        [selectedTabIndex]="selectedTabIndex()"> </dsy-tabs>
    </div>
    <div class="home-header__controls" [class.no-switcher]="!showSwitcher()">
      @if (showSwitcher()) {
      <div class="home-header__switcher">
        <dsy-content-switcher [contentList]="switchItems()" [indexContentChosed]="switchIndex()" [functionSetterData]="handleSwitch"> </dsy-content-switcher>
      </div>
      }
    </div>
  </div>
  <div class="home-body">
    <div class="home-body__content">
      <router-outlet />
    </div>
  </div>
</div>
}
